import cloneDeep from 'lodash/cloneDeep';

const reorderItems = <T>(items: T[], sourceIndex: number, destinationIndex: number) => {
	const copy = cloneDeep(items);

	const [moved] = copy.splice(sourceIndex, 1);
	copy.splice(destinationIndex, 0, moved);

	return copy;
};

export { reorderItems };
